
import React, { Component } from 'react';
import {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';

import Chip from '@material-ui/core/Chip';
import { grey } from '@material-ui/core/colors';

import TableListSort from 'core/TableListSort';


export default class TractorUnitTable extends Component {
  render() {
    const { items, onDetail } = this.props;
    return (
      <React.Fragment>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row" className={'w-10 hide-on-mobile'}>
              <TableListSort label={'#'} name={'id'} />
            </TableCell>
            <TableCell component="th" scope="row" className={'w-200'}>
              <TableListSort label={'Регистрационный знак'} name={'number'} />
            </TableCell>
            <TableCell component="th" scope="row" className={'w-120'}>Год выпуска</TableCell>
            <TableCell component="th" scope="row">Модель</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {items.map(item =>
          <TableRow
            key={item.id}
            hover={true}
            className={'pointer'}
            onClick={(event) => onDetail(item)}
            style={{
              backgroundColor: item.is_active ? 'inherit' : grey[200]
            }}
          >
            <TableCell className={'hide-on-mobile'}>{item.id}</TableCell>
            <TableCell>
              {item.number}
              {!item.is_active && <Chip label={'Неактивно'} className={'ml-10'} size={'small'} />}
            </TableCell>
            <TableCell>{item.year}</TableCell>
            <TableCell>{item.type && item.type.label}</TableCell>
          </TableRow>
        )}
        </TableBody>
      </React.Fragment>
    )
  }
}
